module.exports = __webpack_public_path__ + "803e975ca85e4d76969c10ec976cb828.png";